import {
  CreateCompanySettingsVersionDocument,
  CreateCompanySettingsVersionMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateAttendanceCompanySettingsVersion = () => {
  const [createCompanySettingsVersion, { loading }] = useMutation(
    CreateCompanySettingsVersionDocument,
    {
      extractorFn: (data) => data.attendanceMutations.createAttendanceCompanySettingsVersion,
    }
  )

  const createSettingsVersion = (variables: CreateCompanySettingsVersionMutationVariables) => {
    return createCompanySettingsVersion({ variables })
  }

  return {
    loading,
    createSettingsVersion,
  }
}
